<template>
	<v-footer padless>
		<v-card flat tile class="white--text py-12 px-12 neftysGradientHard">
      <v-row>
        <v-col cols="12" md="2">
          <v-img
              class="w-100"
              max-width="120"
              src="@/assets/img/logo-neftys-white.svg"
              contain
          />
        </v-col>
        <v-col cols="12" md="2">
          <h4 class="white--text">{{ $t('foot.neftys') }}</h4>
          <div class="hr white"></div>
          <div class="mt-3 pl-3">
            <a href="#"  class="white--text">{{ $t('nav.home') }}</a><br />
            <a href="#nosotros"  class="white--text">{{ $t('nav.nosotros') }}</a><br />
            <a href="#sectores"  class="white--text">{{ $t('nav.sectores') }}</a><br />
            <a href="#servicios"  class="white--text">{{ $t('nav.servicios') }}</a><br />
            <a href="#contacto"  class="white--text">{{ $t('nav.contacto') }}</a><br />
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <h4 class="white--text">{{ $t('foot.gestiones') }}</h4>
          <div class="hr white"></div>
          <div class="mt-3 pl-3">
            <a href="#"  class="white--text">{{ $t('nav.home') }}</a><br />
            <a href="https://pedidos.soladomingo.com/sldmg/identificar.asp" target="_blank" class="white--text">{{ $t('nav.tienda') }}</a><br />
            <a href="https://order.soladomingo.com/" target="_blank" class="white--text">{{ $t('nav.pedidos') }}</a><br />
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <h4 class="white--text">{{ $t('info.info') }}</h4>
          <div class="hr white"></div>
          <div class="mt-3 pl-3">
            <div  v-for="(item, i) in info" :key="i">
            <router-link :to="item.path" class="white--text">
              {{ $t(item.name) }}
            </router-link>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <h4 class="white--text">{{ $t('nav.delegacion1') }}</h4>
          <div class="hr white"></div>
          <div class="mt-3 pl-3">
            <p>Carrer dels Fusters, 3 · Polígono H6(Autovía de Bellisens) · 43204 Reus (Tarragona)</p>
          </div>
          <h4 class="white--text">{{ $t('nav.delegacion2') }}</h4>
          <div class="hr white"></div>
          <div class="mt-3 pl-3">
            <p>Carrer Torelló, 17-19 · 08500 Vic (Barcelona)</p>
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <h4 class="white--text">{{ $t('nav.contacto') }}</h4>
          <div class="hr white"></div>
          <div class="mt-3 pl-3">
            <p>
              {{ $t('info.dias') }}<br />
              {{ $t('info.horas') }}<br />
              {{ $t('info.numTelefono') }}<br />
              ventas.sd@neftysfarma.es
            </p>
          </div>
        </v-col>
      </v-row>

			<v-divider></v-divider>

			<v-card-text class="d-flex justify-center align-center info--text text-center">
				Copyright &copy; {{ new Date().getFullYear() }} Powered by
				<svg xmlns="http://www.w3.org/2000/svg" width="88.248" height="20" viewBox="0 0 88.248 29.763">
					<g id="Grupo_133" data-name="Grupo 133" transform="translate(-161.871 359.201)">
						<g id="Grupo_130" data-name="Grupo 130" transform="translate(161.871 -359.201)">
							<g id="Grupo_128" data-name="Grupo 128">
								<path
									id="Trazado_348"
									data-name="Trazado 348"
									d="M169.183,538.407a17.489,17.489,0,0,0-2.891-10.176c1.306-.637,1.923-1.957,1.923-4.059v-.749H166.2v.507c0,1.63-.737,2.282-2.584,2.282h-3.356c-1.739,0-2.692.954-2.886,2.837h-.326c-.193-1.884-1.147-2.837-2.886-2.837h-3.32c-1.847,0-2.584-.64-2.584-2.282v-.507h-2.016v.749c0,2.184.66,3.524,2.064,4.131a17.515,17.515,0,0,0-2.842,10.1,17.2,17.2,0,0,0,3.372,10.846,15.949,15.949,0,0,0-2.594,1.64v2.294c2.222-1.739,6.858-3.1,11-3.1s8.765,1.364,10.975,3.1v-2.294a15.87,15.87,0,0,0-2.453-1.574A17.183,17.183,0,0,0,169.183,538.407Zm-18.764-9.721.1,0h2.825c1.883,0,2.523.712,2.535,2.728h2.668c.012-2.016.664-2.728,2.536-2.728h2.837c.1,0,.207,0,.308-.006a22.037,22.037,0,0,1,2.29,9.737q0,.193,0,.387a5.1,5.1,0,0,0-2.594-.573h-2.837c-1.871,0-2.524-.712-2.536-2.729h-2.668c-.012,2.016-.652,2.729-2.535,2.729h-2.825a5.323,5.323,0,0,0-2.381.465c0-.093,0-.186,0-.279A22.042,22.042,0,0,1,150.419,528.687Zm6.81,18.729a19.355,19.355,0,0,0-6.611,1.068,19.748,19.748,0,0,1-2.2-6.594c.307-.834,1.062-1.181,2.419-1.181h3.32c1.739,0,2.693-.954,2.886-2.837h.326c.193,1.883,1.147,2.837,2.886,2.837h3.356c1.576,0,2.341.477,2.533,1.628a19.236,19.236,0,0,1-2.151,6.2A19.262,19.262,0,0,0,157.228,547.416Z"
									transform="translate(-145.463 -523.424)"
									fill="#27debf"
								/>
								<ellipse
									id="Elipse_3"
									data-name="Elipse 3"
									cx="1.775"
									cy="1.739"
									rx="1.775"
									ry="1.739"
									transform="translate(5.994 7.412)"
									fill="#27debf"
								/>
								<ellipse
									id="Elipse_4"
									data-name="Elipse 4"
									cx="1.775"
									cy="1.739"
									rx="1.775"
									ry="1.739"
									transform="translate(14.078 7.412)"
									fill="#27debf"
								/>
							</g>
						</g>
					</g>
					<path
						id="ntec"
						d="M3.961-5.535H6.369V-17.3c0-3.732,2.39-6.2,5.883-6.2,3.438,0,5.166,1.93,5.166,5.7V-5.535h2.408V-18.4c0-4.614-2.518-7.261-6.93-7.261-3.162,0-5.349,1.452-6.4,3.9H6.259v-3.566h-2.3Zm21.56-16.147v3.289H23.467v2.042h2.054v7.42c0,2.481,1.128,3.479,3.965,3.479a8.246,8.246,0,0,0,1.389-.131v-2.03a8.409,8.409,0,0,1-.974.059c-1.27,0-1.828-.605-1.828-1.995v-6.8h2.8v-2.042h-2.8v-3.289ZM42.214-8.989a3.072,3.072,0,0,1-3.075,1.615c-2.042,0-3.36-1.472-3.443-3.811V-11.3h9.13v-.879c0-4.037-2.173-6.494-5.77-6.494-3.645,0-5.96,2.624-5.96,6.72,0,4.12,2.268,6.672,5.972,6.672,2.956,0,5.046-1.425,5.6-3.7Zm-3.17-7.61c1.888,0,3.122,1.365,3.182,3.455H35.7A3.361,3.361,0,0,1,39.044-16.6Zm19.791,2.315c-.332-2.505-2.291-4.393-5.533-4.393-3.764,0-6.055,2.553-6.055,6.649,0,4.179,2.3,6.744,6.067,6.744,3.194,0,5.188-1.793,5.521-4.333H56.354A2.822,2.822,0,0,1,53.3-7.458c-2.125,0-3.443-1.722-3.443-4.571,0-2.79,1.306-4.476,3.443-4.476a2.9,2.9,0,0,1,3.051,2.22Z"
						transform="translate(29.413 30.237)"
						fill="white"
					/>
				</svg>
			</v-card-text>
		</v-card>
	</v-footer>
</template>

<script>
export default {
	name: 'FooterView',
	data: () => ({
		/* enlaces: [
      {
        path: "/Nosotros",
        name: "nav.nosotros",
      },
      {
        path: "/contacto",
        name: "nav.contacto",
      },
    ], */
		info: [
			{
				path: '/legal',
				name: 'info.aviso',
			},
			{
				path: '/Politica',
				name: 'info.privacidad',
			},
			{
				path: '/coockies',
				name: 'info.cookies',
			},
		],
	}),
};
</script>

<style scoped>
.v-card {
	width: 100%;
}

.hr {
	border-top: 2px solid;
	width: 8vw;
	margin-top: 5px;
}

.neftysGradientHard {
  background: rgb(44,86,159);
  background: linear-gradient(131deg, #2c569f 50%, #099247 100%);
}

</style>
